// Style
import "./App.sass";

// Layouts
//Components
import { Toaster } from "react-hot-toast";
import Menu from "@src/components/Menu/Menu";
import Stack from "@src/components/Stack/Stack";
import { useUserStore } from "./stores/userStore";
// Zustand
import { useShallow } from "zustand/react/shallow";
import { useQuery } from "@tanstack/react-query";
import { api } from "./utils/axios-instance";
import { useEffect } from "react";
import Loader from "./components/Loader/Loader";
import { Outlet } from "react-router";
import { getGlobalAppSettings } from "./services/requests/app";
import { Preferences } from "./types/global";
import { useGlobalSettings } from "./hooks/useGlobalSettings";
import { isTrue } from "./utils/string";
import { MessageBanner } from "./layout/MessageBanner";

function App() {
    const { authenticate, isLoggedIn, preferences } = useUserStore(
        useShallow((state) => ({
            authenticate: state.authenticate,
            isLoggedIn: state.isLoggedIn,
            preferences: state.preferences,
        })),
    );
    const setPreferences = useUserStore.getState().setPreferences;
    const fetchUserPreferences = async (): Promise<Preferences> => {
        const { data } = (await api.get("/users/settings")) as any;
        return data.data.preferences;
    };
    const globalAppSettingsQuery = useQuery({
        queryKey: ["globalAppSettings"],
        queryFn: getGlobalAppSettings,
        staleTime: 3400 * 1000,
    });
    const preferencesQuery = useQuery<Preferences>({
        queryKey: ["userPref"],
        queryFn: fetchUserPreferences,
        placeholderData: preferences,
        enabled: isLoggedIn,
        staleTime: 60 * 1000,
    });

    const globalSettings = useGlobalSettings();
    const {
        is_under_maintenance = "false",
        admin_message,
        display_admin_message = "false",
    } = globalSettings || {};
    useEffect(() => {
        setPreferences(preferencesQuery.data!);
    }, [preferencesQuery.isFetchedAfterMount]);
    const localToken = localStorage.getItem("token");
    if (localToken != null && isLoggedIn == false) {
        authenticate();
    }
    return (
        <main>
            {isTrue(display_admin_message) && (
                <MessageBanner message={admin_message} />
            )}
            <Toaster />
            {!isTrue(is_under_maintenance) && <Menu />}
            {isLoggedIn && <Stack />}
            {preferencesQuery.isPending && globalAppSettingsQuery.isPending ? (
                <Loader />
            ) : (
                <Outlet />
            )}
        </main>
    );
}

export default App;
